import { WorkflowReportCompletionRateDataType, WorkflowReportCompletionRatesOverTimeResponse, WorkflowReportFraudResponse, WorkflowReportPassRateDataType, WorkflowReportPassRatesOverTimeResponse, WorkflowReportStepByStepResponse, WorkflowReportVolumesByAppIdResponse, WorkflowReportVolumesByCountryResponse } from "@idw-types/data/reports/workflow-report";
import {
    WorkflowReportSearchFiltersState,
    WorkflowReportMetadataSearchResults,
    WorkflowReportMetadataSearchFilters,
    WorkflowReportSearchResultsTypes
} from "@idw-types/state/workflow-report-state";

export enum WorkflowReportActionTypes {
    // Search
    SET_WORKFLOW_REPORT_SEARCH_FILTERS = "SET_WORKFLOW_REPORT_SEARCH_FILTERS",
    SET_PARTIAL_WORKFLOW_REPORT_SEARCH_RESULTS_LOADING = "SET_PARTIAL_WORKFLOW_REPORT_SEARCH_RESULTS_LOADING",
   
    SET_WORKFLOW_REPORT_SEARCH_RESULTS = "SET_WORKFLOW_REPORT_SEARCH_RESULTS",
    SET_WORKFLOW_REPORT_SEARCH_RESULTS_PASS_RATE_AND_OVER_TIME = "SET_WORKFLOW_REPORT_SEARCH_RESULTS_PASS_RATE_AND_OVER_TIME",
    SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE = "SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE",
    SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE_OVER_TIME = "SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE_OVER_TIME",
    SET_WORKFLOW_REPORT_SEARCH_RESULTS_STEP_BY_STEP = "SET_WORKFLOW_REPORT_SEARCH_RESULTS_STEP_BY_STEP",

    SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_APP_ID = "SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_APP_ID",
    SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_COUNTRY = "SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_COUNTRY",
    SET_WORKFLOW_REPORT_SEARCH_RESULTS_FRAUD = "SET_WORKFLOW_REPORT_SEARCH_RESULTS_FRAUD",
    // Metadata Search
    SET_WORKFLOW_REPORT_METADATA_SEARCH_FILTERS = "SET_WORKFLOW_REPORT_METADATA_SEARCH_FILTERS",
    SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS_LOADING = "SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS_LOADING",
    SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS = "SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS",
    SET_WORKFLOW_REPORT_SEARCHED_METADATA_SEARCH_RESULTS = "SET_WORKFLOW_REPORT_SEARCHED_METADATA_SEARCH_RESULTS"
}

// Search
type SetWorkflowReportSearchFiltersAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_FILTERS;
    payload: { searchFilters: WorkflowReportSearchFiltersState };
};

export const setWorkflowReportSearchFilters = (
    searchFilters: WorkflowReportSearchFiltersState
): SetWorkflowReportSearchFiltersAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetPartialWorkflowReportSearchResultsLoadingAction = {
    type: WorkflowReportActionTypes.SET_PARTIAL_WORKFLOW_REPORT_SEARCH_RESULTS_LOADING,
    payload: {
        isLoading: boolean;
        dataType: WorkflowReportSearchResultsTypes;
    }
}

export const setPartialWorkflowReportSearchResultsLoading = (
    isLoading: boolean,
    dataType: WorkflowReportSearchResultsTypes
): SetPartialWorkflowReportSearchResultsLoadingAction => ({
    type: WorkflowReportActionTypes.SET_PARTIAL_WORKFLOW_REPORT_SEARCH_RESULTS_LOADING,
    payload: { isLoading, dataType }
});

type SetWorkflowReportSearchResultsPassRateAndOverTimeAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_PASS_RATE_AND_OVER_TIME;
    payload: {
        passRates: WorkflowReportPassRateDataType;
        passRatesOverTime: WorkflowReportPassRatesOverTimeResponse;
    };
};

export const setWorkflowReportSearchResultsPassRateAndOverTime = (
    passRates: WorkflowReportPassRateDataType,
    passRatesOverTime: WorkflowReportPassRatesOverTimeResponse
): SetWorkflowReportSearchResultsPassRateAndOverTimeAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_PASS_RATE_AND_OVER_TIME,
    payload: { passRates, passRatesOverTime }
});

type SetWorkflowReportSearchResultsCompletionRateAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE;
    payload: {
        completionRates: WorkflowReportCompletionRateDataType;
    };
};
export const setWorkflowReportSearchResultsCompletionRate = (
    completionRates: WorkflowReportCompletionRateDataType
): SetWorkflowReportSearchResultsCompletionRateAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE,
    payload: { completionRates }
});

type SetWorkflowReportSearchResultsCompletionRateOverTimeAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE_OVER_TIME;
    payload: {
      
        completionRatesOverTime: WorkflowReportCompletionRatesOverTimeResponse;
    };
};
export const setWorkflowReportSearchResultsCompletionRateAndOverTime = (
    completionRatesOverTime: WorkflowReportCompletionRatesOverTimeResponse
): SetWorkflowReportSearchResultsCompletionRateOverTimeAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_COMPLETION_RATE_OVER_TIME,
    payload: { completionRatesOverTime }
});

type SetWorkflowReportSearchResultsStepByStepAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_STEP_BY_STEP;
    payload: { stepByStep: WorkflowReportStepByStepResponse; };
};

export const setWorkflowReportSearchResultsStepByStep = (
    stepByStep: WorkflowReportStepByStepResponse
): SetWorkflowReportSearchResultsStepByStepAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_STEP_BY_STEP,
    payload: { stepByStep }
});

type SetWorkflowReportSearchResultsVolumeByAppIdAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_APP_ID;
    payload: { volumesByAppID: WorkflowReportVolumesByAppIdResponse; };
};

export const setWorkflowReportSearchResultsVolumeByAppId = (
    volumesByAppID: WorkflowReportVolumesByAppIdResponse
): SetWorkflowReportSearchResultsVolumeByAppIdAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_APP_ID,
    payload: { volumesByAppID }
});

type SetWorkflowReportSearchResultsVolumeByCountryAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_COUNTRY;
    payload: { volumesByCountry: WorkflowReportVolumesByCountryResponse; };
};

export const setWorkflowReportSearchResultsVolumeByCountry = (
    volumesByCountry: WorkflowReportVolumesByCountryResponse
): SetWorkflowReportSearchResultsVolumeByCountryAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_VOLUME_BY_COUNTRY,
    payload: { volumesByCountry }
});

type SetWorkflowReportSearchResultsFraudAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_FRAUD;
    payload: {  fraud: WorkflowReportFraudResponse; };
};

export const setWorkflowReportSearchResultsFraud = (
    fraud: WorkflowReportFraudResponse
): SetWorkflowReportSearchResultsFraudAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCH_RESULTS_FRAUD,
    payload: { fraud }
});


// Metadata Search
type SetWorkflowReportMetadataSearchFiltersAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_METADATA_SEARCH_FILTERS,
    payload: { searchFilters: WorkflowReportMetadataSearchFilters };
};

export const setWorkflowReportMetadataSearchFilters = (
    searchFilters: WorkflowReportMetadataSearchFilters
): SetWorkflowReportMetadataSearchFiltersAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_METADATA_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetWorkflowReportMetadataSearchResultsLoadingAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setWorkflowReportMetadataSearchResultsLoading = (
    isLoading: boolean
): SetWorkflowReportMetadataSearchResultsLoadingAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetWorkflowReportMetadataSearchResultsAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS;
    payload: { workflowReportMetadataSearchResults: WorkflowReportMetadataSearchResults };
};

export const setWorkflowReportMetadataSearchResults = (
    workflowReportMetadataSearchResults: WorkflowReportMetadataSearchResults
): SetWorkflowReportMetadataSearchResultsAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_METADATA_SEARCH_RESULTS,
    payload: { workflowReportMetadataSearchResults }
});

type SetWorkflowReportSearchedMetadataSearchResultsAction = {
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCHED_METADATA_SEARCH_RESULTS;
    payload: { workflowReportMetadataSearchResults: WorkflowReportMetadataSearchResults };
};

export const setWorkflowReportSearchedMetadataSearchResults = (
    workflowReportMetadataSearchResults: WorkflowReportMetadataSearchResults
): SetWorkflowReportSearchedMetadataSearchResultsAction => ({
    type: WorkflowReportActionTypes.SET_WORKFLOW_REPORT_SEARCHED_METADATA_SEARCH_RESULTS,
    payload: { workflowReportMetadataSearchResults }
});


export type WorkflowReportActions =
    // Search
    SetWorkflowReportSearchFiltersAction |
    SetPartialWorkflowReportSearchResultsLoadingAction |
    SetWorkflowReportSearchResultsPassRateAndOverTimeAction |
    SetWorkflowReportSearchResultsStepByStepAction |
    SetWorkflowReportSearchResultsVolumeByAppIdAction | 
    SetWorkflowReportSearchResultsVolumeByCountryAction |
    SetWorkflowReportSearchResultsCompletionRateAction |
    SetWorkflowReportSearchResultsCompletionRateOverTimeAction |
    SetPartialWorkflowReportSearchResultsLoadingAction |
    SetWorkflowReportSearchResultsFraudAction |
    // Metadata Search
    SetWorkflowReportMetadataSearchFiltersAction |
    SetWorkflowReportMetadataSearchResultsLoadingAction |
    SetWorkflowReportMetadataSearchResultsAction |
    SetWorkflowReportSearchedMetadataSearchResultsAction